// extracted by mini-css-extract-plugin
export default {"maincontainer":"EditContact_maincontainer__P6cDj"};